import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    storage,
    key: 'demo1-auth',
    whitelist: ['user', 'authToken']
};

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: undefined,
        authToken: undefined,
    },
    reducers: {
        login: (state, { payload }) => {
            state.authToken = payload.token;
            state.user = payload.user;
        },
        register: (state, { payload }) => {
            state.authToken = payload;
            state.user = undefined;
        },
        logout: (state) => {
            state.user = undefined;
            state.authToken = undefined;
            localStorage.removeItem('sessionUser');
            localStorage.removeItem('newEmail');
            localStorage.removeItem('store');
        }
    }
});

export const reducer = persistReducer(persistConfig, authSlice.reducer);
export const actions = authSlice.actions;
